<template>
    <div class="main">
        <c-panel>
            <form-periodo :paramId="$route.params.id" v-on:onSubmit="onSubmit"></form-periodo>
        </c-panel>
    </div>
</template>

<script>
import formPeriodo from './form'

export default {
    methods: {
        onSubmit () {
            this.$router.push('/admin/tabulacao/periodos')
        }
    },
    components: { formPeriodo }
}
</script>
